import styles from "./Header.module.css";
import { Attribution } from "src/components/OfferPage/Attribution";
import { Site, USPAttributesGroup } from "@/types/sites";
import type { OfferPageTemplateResponse } from "@/types/offers";
import { USPAttributesIconGroup } from "@/components/common/USPAttributesIconGroup";
import { useContext } from "react";
import {
    LockedContext,
    type LockedContextType,
} from "src/contexts/LockedContext";
import { enableBrTags } from "../../../utils/titleUtils";

export const Header = ({
    site,
    offerPage,
    pageUSPAttributes,
}: {
    site: Site;
    offerPage: OfferPageTemplateResponse;
    pageUSPAttributes?: USPAttributesGroup | null;
}): React.ReactElement => {
    const { isLocked } = useContext<LockedContextType>(LockedContext);

    const hasSubtitle =
        offerPage?.data?.attributes?.subtitle &&
        offerPage?.data?.attributes?.subtitle.trim() != "";

    const title =
        isLocked && offerPage?.data?.attributes?.lockedTitle
            ? offerPage?.data?.attributes?.lockedTitle
            : offerPage?.data?.attributes?.title;

    return (
        <section id="header" className={styles.header}>
            <h1 className={styles.title}>{enableBrTags(title)}</h1>
            <div className={styles.desktopHeadings}>
                {hasSubtitle ? (
                    <h2 className={styles.subtitle}>
                        {enableBrTags(offerPage?.data?.attributes?.subtitle)}
                    </h2>
                ) : null}
                {site?.attributes?.attributions?.data?.length > 0 &&
                    !pageUSPAttributes && (
                        <div className={styles.attributions}>
                            {site?.attributes?.attributions?.data.map(
                                (attribution) => {
                                    return (
                                        <Attribution
                                            key={attribution.id}
                                            className={styles.attribution}
                                            attribution={attribution.attributes}
                                        />
                                    );
                                }
                            )}
                        </div>
                    )}
            </div>
            {pageUSPAttributes && (
                <USPAttributesIconGroup pageUSPAttributes={pageUSPAttributes} />
            )}
        </section>
    );
};
